// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern AI-Style Courses Page */

.Courses-main {
    min-height: calc(100vh - 80px);
    padding: 40px 60px;
    background: #ffffff;
    position: relative;
    margin-top: 60px;
}

/* Header Section */
.coursesHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
    position: relative;
    z-index: 1;
    flex-wrap: wrap;
    gap: 24px;
    animation: fadeInUp 0.6s ease-out;
}

.coursesHeaderContent {
    display: flex;
    align-items: center;
    gap: 24px;
    flex: 1 1;
}

.coursesHeaderIconWrapper {
    width: 70px;
    height: 70px;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(102, 126, 234, 0.2);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.coursesHeaderIconWrapper:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);
}

.coursesHeaderIcon {
    font-size: 36px !important;
    color: #667eea !important;
}

.coursesMainTitle {
    font-size: 42px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 8px 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
}

.coursesSubtitle {
    font-size: 16px;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
    font-weight: 400;
}

/* Search Wrapper */
/* .coursesSearchWrapper {
    position: relative;
    z-index: 1;
} */

.coursesSearchInput {
    width: 350px;
    overflow: hidden;
}

.coursesSearchInput .ant-input {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    /* padding: 12px 16px 12px 45px !important; */
    font-size: 15px !important;
    /* height: 48px !important; */
}

.coursesSearchInput .ant-input:focus {
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
}

.coursesSearchInput .ant-input-prefix {
    left: 16px;
}

.searchIcon {
    color: #667eea !important;
    font-size: 20px !important;
}

/* Loader */
.coursesLoader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    position: relative;
    z-index: 1;
}

/* Content Section */
.coursesContent {
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease-out 0.2s both;
}

/* Communication Card */
.communicationCardWrapper {
    margin-bottom: 32px;
}

.communicationCard {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 20px !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
    overflow: hidden;
    transition: all 0.3s ease !important;
    cursor: pointer;
}

.communicationCard:hover {
    transform: translateY(-8px) scale(1.02) !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
}

.communicationCardCover {
    position: relative;
    height: 200px;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.communicationCardOverlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.communicationCard:hover .communicationCardOverlay {
    background: rgba(0, 0, 0, 0.5);
}

.communicationIcon {
    font-size: 64px !important;
    color: rgba(255, 255, 255, 0.9) !important;
    transition: all 0.3s ease;
}

.communicationCard:hover .communicationIcon {
    transform: scale(1.1);
}

.communicationCardImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.7;
    transition: all 0.3s ease;
}

.communicationCard:hover .communicationCardImage {
    opacity: 0.5;
    transform: scale(1.1);
}

.communicationCardContent {
    padding: 24px;
    position: relative;
}

.communicationBadge {
    position: absolute;
    top: -15px;
    right: 24px;
    font-size: 32px !important;
    color: #667eea !important;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 50%;
    padding: 8px;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.communicationCardTitle {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin: 8px 0 8px 0;
}

.communicationCardDescription {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
}

/* Courses Grid */
.coursesGrid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 24px;
}

/* Course Card */
.courseCard {
    background: rgba(255, 255, 255, 0.95) !important;
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
    overflow: hidden;
    transition: all 0.3s ease !important;
    cursor: pointer;
}

.courseCard:hover {
    transform: translateY(-8px) scale(1.02) !important;
    box-shadow: 0 16px 48px rgba(102, 126, 234, 0.25) !important;
    border-color: rgba(102, 126, 234, 0.4) !important;
}

.courseCardCover {
    position: relative;
    height: 200px;
    overflow: hidden;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.courseCardOverlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardOverlay {
    opacity: 0;
}

.playIcon {
    font-size: 64px !important;
    color: rgba(255, 255, 255, 0.95) !important;
    transition: all 0.3s ease;
}

.courseCard:hover .playIcon {
    transform: scale(1.1);
}

.courseCardImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardImage {
    transform: scale(1.1);
}

.courseCardContent {
    padding: 24px;
}

.courseCardHeader {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 8px;     
}

.courseCardIcon {
    font-size: 24px !important;
    color: #667eea !important;
    margin-top: 2px;
    flex-shrink: 0;
}

.Courses-main .courseCardTitle {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin: 0;
    line-height: 1.4;
    flex: 1 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.courseCardFooter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.courseCardAction {
    font-size: 14px;
    font-weight: 600;
    color: #667eea;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardAction {
    color: #764ba2;
}

.courseCardArrow {
    font-size: 20px !important;
    color: #667eea !important;
    transition: all 0.3s ease;
}

.courseCard:hover .courseCardArrow {
    transform: translateX(4px);
    color: #764ba2 !important;
}

/* Empty State */
.coursesEmptyState {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    background: rgba(255, 255, 255, 0.95);
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 40px;
}

/* Animations */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 1200px) {
    .Courses-main {
        padding: 30px 40px;
    }

    .coursesGrid {
        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
        gap: 20px;
    }
}

@media (max-width: 768px) {
    .Courses-main {
        padding: 30px 20px;
    }

    .coursesHeader {
        flex-direction: column;
        align-items: flex-start;
    }

    .coursesHeaderContent {
        width: 100%;
    }

    .coursesHeaderIconWrapper {
        width: 60px;
        height: 60px;
    }

    .coursesHeaderIcon {
        font-size: 30px !important;
    }

    .coursesMainTitle {
        font-size: 32px;
    }

    .coursesSubtitle {
        font-size: 14px;
    }

    /* .coursesSearchWrapper {
        width: 100%;
    } */

    .coursesSearchInput {
        width: 100% !important;
    }

    .coursesGrid {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .courseCardCover,
    .communicationCardCover {
        height: 180px;
    }
}

@media (max-width: 480px) {
    .Courses-main {
        padding: 20px 16px;
    }

    .coursesMainTitle {
        font-size: 28px;
    }

    .courseCardContent,
    .communicationCardContent {
        padding: 20px;
    }
}

.communicationCard,
.courseCard {
    display: flex;
    flex-direction: column;
    height: 360px;          
    max-height: 360px;
}

.communicationCardCover,
.courseCardCover {
    height: 160px;  
    flex-shrink: 0;
}

.communicationCard .ant-card-body,
.courseCard .ant-card-body {
    display: flex;
    flex-direction: column;
    padding: 20px;
    flex: 1 1;
}

.courseCardFooter {
    margin-top: auto;  
    padding-top: 12px;
}

.courseCardHeader {
    margin-bottom: 10px;
}

.communicationCardTitle,
.courseCardTitle {
    margin-bottom: 6px;
}

.courseCardContent,
.communicationCardContent {
    display: flex;
    flex-direction: column;
    flex: 1 1;           
}

.courseCardFooter {
    margin-top: 33px;  
}

`, "",{"version":3,"sources":["webpack://./src/Components/Courses/Courses.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,gDAAgD;IAChD,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;;;GAGG;;AAEH;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,6CAA6C;IAC7C,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,WAAW;AACX;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,UAAU;IACV,2CAA2C;AAC/C;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,sDAAsD;IACtD,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,gDAAgD;IAChD,mCAA2B;YAA3B,2BAA2B;IAC3B,qDAAqD;IACrD,8BAA8B;IAC9B,oDAAoD;IACpD,gBAAgB;IAChB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,4DAA4D;IAC5D,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,2CAA2C;IAC3C,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,SAAO;IACP,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,4DAA4D;QAC5D,SAAS;IACb;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;OAEG;;IAEH;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* Modern AI-Style Courses Page */\n\n.Courses-main {\n    min-height: calc(100vh - 80px);\n    padding: 40px 60px;\n    background: #ffffff;\n    position: relative;\n    margin-top: 60px;\n}\n\n/* Header Section */\n.coursesHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px;\n    position: relative;\n    z-index: 1;\n    flex-wrap: wrap;\n    gap: 24px;\n    animation: fadeInUp 0.6s ease-out;\n}\n\n.coursesHeaderContent {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    flex: 1;\n}\n\n.coursesHeaderIconWrapper {\n    width: 70px;\n    height: 70px;\n    background: rgba(102, 126, 234, 0.1);\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid rgba(102, 126, 234, 0.2);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\n    transition: all 0.3s ease;\n    flex-shrink: 0;\n}\n\n.coursesHeaderIconWrapper:hover {\n    transform: translateY(-5px) scale(1.05);\n    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);\n}\n\n.coursesHeaderIcon {\n    font-size: 36px !important;\n    color: #667eea !important;\n}\n\n.coursesMainTitle {\n    font-size: 42px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 0 0 8px 0;\n    line-height: 1.2;\n    letter-spacing: -0.5px;\n}\n\n.coursesSubtitle {\n    font-size: 16px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.6;\n    font-weight: 400;\n}\n\n/* Search Wrapper */\n/* .coursesSearchWrapper {\n    position: relative;\n    z-index: 1;\n} */\n\n.coursesSearchInput {\n    width: 350px;\n    overflow: hidden;\n}\n\n.coursesSearchInput .ant-input {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    /* padding: 12px 16px 12px 45px !important; */\n    font-size: 15px !important;\n    /* height: 48px !important; */\n}\n\n.coursesSearchInput .ant-input:focus {\n    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;\n}\n\n.coursesSearchInput .ant-input-prefix {\n    left: 16px;\n}\n\n.searchIcon {\n    color: #667eea !important;\n    font-size: 20px !important;\n}\n\n/* Loader */\n.coursesLoader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    position: relative;\n    z-index: 1;\n}\n\n/* Content Section */\n.coursesContent {\n    position: relative;\n    z-index: 1;\n    animation: fadeInUp 0.8s ease-out 0.2s both;\n}\n\n/* Communication Card */\n.communicationCardWrapper {\n    margin-bottom: 32px;\n}\n\n.communicationCard {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;\n    overflow: hidden;\n    transition: all 0.3s ease !important;\n    cursor: pointer;\n}\n\n.communicationCard:hover {\n    transform: translateY(-8px) scale(1.02) !important;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;\n}\n\n.communicationCardCover {\n    position: relative;\n    height: 200px;\n    overflow: hidden;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.communicationCardOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease;\n}\n\n.communicationCard:hover .communicationCardOverlay {\n    background: rgba(0, 0, 0, 0.5);\n}\n\n.communicationIcon {\n    font-size: 64px !important;\n    color: rgba(255, 255, 255, 0.9) !important;\n    transition: all 0.3s ease;\n}\n\n.communicationCard:hover .communicationIcon {\n    transform: scale(1.1);\n}\n\n.communicationCardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    opacity: 0.7;\n    transition: all 0.3s ease;\n}\n\n.communicationCard:hover .communicationCardImage {\n    opacity: 0.5;\n    transform: scale(1.1);\n}\n\n.communicationCardContent {\n    padding: 24px;\n    position: relative;\n}\n\n.communicationBadge {\n    position: absolute;\n    top: -15px;\n    right: 24px;\n    font-size: 32px !important;\n    color: #667eea !important;\n    background: rgba(255, 255, 255, 0.95);\n    border-radius: 50%;\n    padding: 8px;\n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.communicationCardTitle {\n    font-size: 24px;\n    font-weight: 700;\n    color: #1f2937;\n    margin: 8px 0 8px 0;\n}\n\n.communicationCardDescription {\n    font-size: 14px;\n    color: #6b7280;\n    margin: 0;\n}\n\n/* Courses Grid */\n.coursesGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 24px;\n}\n\n/* Course Card */\n.courseCard {\n    background: rgba(255, 255, 255, 0.95) !important;\n    backdrop-filter: blur(20px);\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    border-radius: 20px !important;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;\n    overflow: hidden;\n    transition: all 0.3s ease !important;\n    cursor: pointer;\n}\n\n.courseCard:hover {\n    transform: translateY(-8px) scale(1.02) !important;\n    box-shadow: 0 16px 48px rgba(102, 126, 234, 0.25) !important;\n    border-color: rgba(102, 126, 234, 0.4) !important;\n}\n\n.courseCardCover {\n    position: relative;\n    height: 200px;\n    overflow: hidden;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.courseCardOverlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardOverlay {\n    opacity: 0;\n}\n\n.playIcon {\n    font-size: 64px !important;\n    color: rgba(255, 255, 255, 0.95) !important;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .playIcon {\n    transform: scale(1.1);\n}\n\n.courseCardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardImage {\n    transform: scale(1.1);\n}\n\n.courseCardContent {\n    padding: 24px;\n}\n\n.courseCardHeader {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-top: 8px;     \n}\n\n.courseCardIcon {\n    font-size: 24px !important;\n    color: #667eea !important;\n    margin-top: 2px;\n    flex-shrink: 0;\n}\n\n.Courses-main .courseCardTitle {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    line-height: 1.4;\n    flex: 1;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.courseCardFooter {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 16px;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.courseCardAction {\n    font-size: 14px;\n    font-weight: 600;\n    color: #667eea;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardAction {\n    color: #764ba2;\n}\n\n.courseCardArrow {\n    font-size: 20px !important;\n    color: #667eea !important;\n    transition: all 0.3s ease;\n}\n\n.courseCard:hover .courseCardArrow {\n    transform: translateX(4px);\n    color: #764ba2 !important;\n}\n\n/* Empty State */\n.coursesEmptyState {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 400px;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px);\n    border-radius: 20px;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    padding: 40px;\n}\n\n/* Animations */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .Courses-main {\n        padding: 30px 40px;\n    }\n\n    .coursesGrid {\n        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n        gap: 20px;\n    }\n}\n\n@media (max-width: 768px) {\n    .Courses-main {\n        padding: 30px 20px;\n    }\n\n    .coursesHeader {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .coursesHeaderContent {\n        width: 100%;\n    }\n\n    .coursesHeaderIconWrapper {\n        width: 60px;\n        height: 60px;\n    }\n\n    .coursesHeaderIcon {\n        font-size: 30px !important;\n    }\n\n    .coursesMainTitle {\n        font-size: 32px;\n    }\n\n    .coursesSubtitle {\n        font-size: 14px;\n    }\n\n    /* .coursesSearchWrapper {\n        width: 100%;\n    } */\n\n    .coursesSearchInput {\n        width: 100% !important;\n    }\n\n    .coursesGrid {\n        grid-template-columns: 1fr;\n        gap: 16px;\n    }\n\n    .courseCardCover,\n    .communicationCardCover {\n        height: 180px;\n    }\n}\n\n@media (max-width: 480px) {\n    .Courses-main {\n        padding: 20px 16px;\n    }\n\n    .coursesMainTitle {\n        font-size: 28px;\n    }\n\n    .courseCardContent,\n    .communicationCardContent {\n        padding: 20px;\n    }\n}\n\n.communicationCard,\n.courseCard {\n    display: flex;\n    flex-direction: column;\n    height: 360px;          \n    max-height: 360px;\n}\n\n.communicationCardCover,\n.courseCardCover {\n    height: 160px;  \n    flex-shrink: 0;\n}\n\n.communicationCard .ant-card-body,\n.courseCard .ant-card-body {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    flex: 1;\n}\n\n.courseCardFooter {\n    margin-top: auto;  \n    padding-top: 12px;\n}\n\n.courseCardHeader {\n    margin-bottom: 10px;\n}\n\n.communicationCardTitle,\n.courseCardTitle {\n    margin-bottom: 6px;\n}\n\n.courseCardContent,\n.communicationCardContent {\n    display: flex;\n    flex-direction: column;\n    flex: 1;           \n}\n\n.courseCardFooter {\n    margin-top: 33px;  \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
